import { RestCampaignData } from '@/types'
import axios from 'axios'
import host from '../../utils/host'

class AccountRest {
  private host: string = host

  public get (token: string | null, campaignId: number): Promise<RestCampaignData> {
    return axios.get(`${this.host}/api/campaigns/${campaignId}/accounts`, token ? {
      headers: {
        Authorization: token
      }
    } : {}).then((res) => res.data)
  }

  public delete (token: string|null, campaignId: number, userId: number): Promise<void> {
    return axios.delete(`${host}/api/campaigns/${campaignId}/accounts/${userId}`, token ? {
      headers: {
        Authorization: token
      }
    } : {}).then((res) => res.data)
  }
}

export default new AccountRest()
